import { createComponent } from '@mtfe/sweet';
import { copyTextToClipboard } from '@mtfe/sweet-utils';
import Toast from '../Toast/script';
import tpl from './dom.html';
import style from './style.less';
import innerTpl from './innerTpl.html';
import Dialog, { hideDialog } from '../common/Dialog/script';

const hideFocusModal = () => {
    hideDialog();
};
const GuidanceSearchModal = (props = {}) => {
    const { onCopyClick, onClose, isRightClose } = props;

    const events = {
        copy: () => {
            const ok = copyTextToClipboard('试吃返现');
            onCopyClick && onCopyClick();
            if (ok) {
                Toast({ message: '复制成功', position: 'center' });
            } else {
                Toast({
                    message: '复制失败，请前往搜索"试吃返现"',
                    position: 'center',
                });
            }
        },
    };
    const focusContent = createComponent(innerTpl, { style }, events);
    const data = {
        renderShareDialog: Dialog({
            contentComponent: focusContent,
            onClose,
            isRightClose,
        }),
    };

    createComponent(tpl, { data });
};

export default GuidanceSearchModal;
export { hideFocusModal };
